import React, { useEffect, useCallback, useRef, useState } from "react";
import CrossCloseButton from "./parts/CrossCloseButton";
import BackButton from "./parts/BackButton";
import RadioButton from "./parts/RadioButton";
import Input from "./parts/Input";
import classNames from "classnames";

export default function ({ onClose, data, settingsData, setSettingsData }) {
  const ref = useRef();

  const formData = settingsData;
  const setFormData = setSettingsData;

  const gweiHandler = (value) => {
    const newFormData = {
      ...formData,
      gwei: value,
    };

    setFormData(newFormData);
  };

  const deadlineHandler = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const slippageRadio = (value, e) => {
    const newFormData = {
      ...formData,
      slippageInput: "",
      [e.target.name]: value,
    };

    setFormData(newFormData);
  };

  const slippageInput = (e) => {
    let value = e.target.value;
    value = value > 100 ? 100 : value;
    e.target.value = value;

    const newFormData = {
      ...formData,
      slippage: value !== "" ? null : data.slippage[0],
      [e.target.name]: value,
    };

    setFormData(newFormData);
  };

  const clickOutTheWindow = useCallback((e) => {
    if (
      ref.current &&
      e.target.closest(".p-settings") !== ref.current &&
      typeof onClose === "function"
    ) {
      onClose(e);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("click", clickOutTheWindow);

    return () => document.removeEventListener("click", clickOutTheWindow);
  }, []);

  return (
    <div ref={ref} className="p-settings">
      <CrossCloseButton
        className="p-settings__close custom-cross-btn_black"
        onClick={onClose}
      />
      <div className="p-settings__header">
        <BackButton className="p-settings__header-btn" onClick={onClose} />
        <div className="p-settings__header-title">Swap Settings</div>
        <div className="p-settings__header-empty">&nbsp;</div>
      </div>
      <div className="p-settings__body">
        <ul className="p-settings__list">
          <li className="p-settings__row">
            <span className="p-settings__list-title">Slippage</span>
            <div className="p-settings__selcs">
              {data.slippage.map((value) => (
                <RadioButton
                  key={value}
                  className="p-settings__radio"
                  id={`slippage-${value}`}
                  value={value}
                  title={`${value}%`}
                  name="slippage"
                  onChange={slippageRadio.bind(null, value)}
                  checked={value === formData.slippage}
                />
              ))}
              <Input
                className={classNames("p-settings__input", {
                  active: formData.slippageInput !== "",
                })}
                type="number"
                name="slippageInput"
                value={formData.slippageInput}
                onChange={slippageInput}
                placeholder="Custom"
              />
            </div>
          </li>
          <li className="p-settings__row">
            <span className="p-settings__list-title">
              Tx Deadline (minutes)
            </span>
            <div className="p-settings__selcs">
              <Input
                className="p-settings__input"
                type="number"
                name="deadline"
                value={formData.deadline}
                onChange={deadlineHandler}
                placeholder="Custom"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
